import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';

interface INetworkLogoutWindowProps {
  onClose(): void;
  onDisconnect(): void;
}

const NetworkLogoutWindow = ({
  onClose,
  onDisconnect,
}: INetworkLogoutWindowProps) => {
  return (
    <div className='gas__deposit_window'>
      <div
        className='price_alert__backdrop'
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      />
      <div className='price_alert__create' onClick={(e) => e.stopPropagation()}>
        {/* to prevent from chart reacting to clicks */}
        <div className='row'>
          <Text size={14} className='text--grey-200 text--weight-600'>
            Change Network Type
          </Text>
          <div
            className='params_panel__param__property__icon icon-close'
            onClick={() => onClose()}
          />
        </div>
        <div className='price_alert__create__new'>
          <div className='priceSelector'>
            <Text size={12} className='text--grey-400'>
              In order to use trading widget on the choosen network you need to
              switch the wallet.
            </Text>
          </div>
          <div className='row'>
            <div className='btnWrapper'>
              <Button
                text='Cancel'
                action={onClose}
                size='s'
                variant='secondary'
              />
            </div>
            <div className='btnWrapper'>
              <Button
                text='Connect'
                action={onDisconnect}
                size='s'
                variant='primary'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkLogoutWindow;
